<template>
  <div class="mb-3">
    <h1 class="headline mb-1"><ressource :code="code" /></h1>
    <v-divider class="my-1"></v-divider>
    <ressource :code="'sous-' + code" hide-if-empty />
</div>
</template>

<script>
export default {
  props: {
    code: { type: String }
  }
}
</script>

<style>
</style>